/**
 * i18n configuration for the frontend-order package.
 *
 * Separate from the staff SPA i18n config (frontend/src/i18n/config.ts).
 * Locale is detected from navigator.language, overridable via ?locale= query param.
 * Namespace: 'order' (single namespace - small app).
 */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enOrder from './locales/en/order.json'
import nlOrder from './locales/nl/order.json'
import frOrder from './locales/fr/order.json'
import esOrder from './locales/es/order.json'

const resources = {
  en: { order: enOrder },
  nl: { order: nlOrder },
  fr: { order: frOrder },
  es: { order: esOrder },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'order',
    ns: ['order'],

    detection: {
      // Check ?locale= query param first, then navigator.language
      order: ['querystring', 'navigator', 'htmlTag'],
      lookupQuerystring: 'locale',
      caches: [], // Do NOT cache locale in localStorage - guest users
    },

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    react: {
      useSuspense: false,
    },
  })

// Sync document lang attribute for screen readers
i18n.on('languageChanged', (lng: string) => {
  document.documentElement.lang = lng.split('-')[0]
})

if (typeof document !== 'undefined' && i18n.language) {
  document.documentElement.lang = i18n.language.split('-')[0]
}

export default i18n

export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'nl', name: 'Dutch', nativeName: 'Nederlands' },
  { code: 'fr', name: 'French', nativeName: 'Français' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
] as const

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]['code']
